import React, { useState } from 'react';
// import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
// import CssBaseline from '@mui/material/CssBaseline';
// import MuiDrawer from '@mui/material/Drawer';
// import Box from '@mui/material/Box';
// import MuiAppBar from '@mui/material/AppBar';
// import Toolbar from '@mui/material/Toolbar';
// import List from '@mui/material/List';
// import Typography from '@mui/material/Typography';
// import Divider from '@mui/material/Divider';
// import IconButton from '@mui/material/IconButton';
// import Badge from '@mui/material/Badge';
// import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
//import Paper from '@mui/material/Paper';
import { Card, Container, Typography, Box, CardContent, Button, CardActions } from '@mui/material';
// import Link from '@mui/material/Link';
// import MenuIcon from '@mui/icons-material/Menu';
// import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
// import NotificationsIcon from '@mui/icons-material/Notifications';
// import { mainListItems, secondaryListItems } from './listItems';
//import Chart from './Chart';

import { Select, MenuItem } from '@mui/material';
import RequestCard from './RequestCard';
import ReportCard from './ReportCard';
import ChatCard from './ChatCard';
import PiaCard from './PiaCard';
// import Deposits from './Deposits';
// import Orders from './Orders';
//import SearchBox from './SearchBox';
//import { useAuth0 } from "@auth0/auth0-react";
// import Button from '@mui/material/Button';
import useSWR from 'swr';
import LoadingOverlay from "react-loading-overlay";
import DarkBackground from "../Widgets/TransparentLoadingDisplay";
import { GetAccessToken, fetcher } from './Utilities';
import GovDashboard from './govDashboard';
//import { set } from 'date-fns';
import { GetAccessTokenM } from './Utilities';
import { set } from 'date-fns';
import { is } from 'date-fns/locale';
import { get } from 'jquery';

function DashboardContent() {

  var accessToken = localStorage.getItem("userToken");

  const [renderCount, setRenderCount] = useState(0);
  //var token = localStorage.getItem("userToken");
  // var token = GetAccessToken(setAccessToken, accessToken,token);
  // console.log(token);
  //console.log(JSON.stringify(localStorage.getItem("userToken")));
  const { data, error } = useSWR(['request/getdashboarddata'], fetcher);
  var isLoading = !data;


  if (error) {
    //debugger;
    window.location.href = "/manuallogin";
    console.log(error);
    //redirect to login page if error is 401
    if (error.status === 401) {
      //alert("Session expired. Please log in again.");
      localStorage.removeItem("userToken");
      window.location.href = "/manuallogin";
    }
    return <div>failed to load</div>
  }
  //const { data, error, isLoading } = useSWR(['request/getdashboarddata', accessToken], fetcher);
  ///console.log(data);
  // const addVendorRequestReminder = (event, cellValues) => {


  //   if (!vendorRequestOpen) {
  //     setreqestReminder(true);
  //     setVendorRequestOpen(true);
  //   }

  // };

  function setTenantId(tenantId) {
    //alert(tenantId);
    fetcher(['request/setAdminTenantId?tenantId=' + tenantId, accessToken, tenantId]);
    window.location.reload();
    //useSWR(['request/setAdminTenantId', tenantId], fetcher);
  }

  function refreshDashboard() {
    setRenderCount(renderCount + 1);
  }

  if (error) return <div>failed to load</div>
  //debugger;
  if (isLoading || !accessToken) {
    return (

      <DarkBackground >
        <LoadingOverlay
          active={true}

          spinner={true}
          text="Loading..."
        >
        </LoadingOverlay>
      </DarkBackground>

    )
  }
  else {
    //console.log(data);
    return (


      <Grid container spacing={3} direction="row" justify="center" alignItems="stretch">
         {/* {renderCount>0 &&
         <>
         <Grid item xs={12} >asdf</Grid>
         </>} */}

        <Grid item xs={12} >
          <Grid>
            <Card variant="outlined">
              <CardContent>
                <RequestCard
                  title="Pending Vendor PIA Requests"
                  rows={data.pendingRequests}
                  refresh={refreshDashboard}
                />
              </CardContent>

            </Card>
          </Grid>
        </Grid>




        <Grid item xs={6} >

          <Grid >
            <Card variant="outlined">
              <CardContent>
                <ReportCard
                  title="Reports"
                  rows={data.reports}
                />
              </CardContent>

            </Card>
          </Grid>

        </Grid>
        <Grid item xs={6} >
          <Grid>
            <Card variant="outlined">
              <CardContent>
                <PiaCard
                  title="PIAs Requiring Updates"
                  rows={data.expiringPias}
                />
              </CardContent>

            </Card>
          </Grid>
        </Grid>

        {/* </Grid> */}

        {/* <Grid item xs={6} >
          <Grid style={{ height: "100%" }}>
            <Card variant="outlined" style={{ height: "100%" }}>
              <CardContent>
                <ChatCard style={{ height: "100%" }}
                  title="PIA Discussion - Under Construction"
                  user={data.user}


                />
              </CardContent>

            </Card>
          </Grid>
        </Grid> */}
        {data.user.hasGovernanceModule &&
          //Governance Dashboard
          <>
            <Grid item xs={12} >
              <Typography variant="h4" component="h2" gutterBottom> Data Governance</Typography>
            </Grid>


            <GovDashboard data={data} accessToken={accessToken} />
          </>

        }
        {data.user.isSuperAdmin &&
          <Select
            defaultValue={''}
            //value={responseData.tenantId}
            label="Select Tenant"
            onChange={(e) => setTenantId(e.target.value)}
          >
            {data.tenants.map((item, index) => <MenuItem key={index} value={item.tenantId}>{item.name}</MenuItem>)}

          </Select>
        }

      </Grid>




      // <Grid style={{ width: '100%' }} container spacing={3}>
      //   {/* Search Bod */}
      //   {/* <Grid item xs={12}>
      //   <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
      //     <SearchBox></SearchBox>
      //   </Paper>
      // </Grid> */}


      //   <Grid item xs={12} md={8} lg={6}>
      //     <Card>
      //       <Paper
      //         sx={{
      //           p: 2,
      //           display: 'flex',
      //           flexDirection: 'column',
      //           height: 300,
      //         }}
      //       >
      //         <RequestCard
      //           title="Pending Vendor PIA Requests"
      //           rows={data.pendingRequests}
      //         />
      //       </Paper>
      //     </Card>
      //   </Grid>
      //   <Grid item xs={12} md={4} lg={6} style={{ height: "100%" }}>
      //     <Card style={{ height: "100%" }}>
      //       <Paper
      //         sx={{
      //           p: 2,
      //           display: 'flex',
      //           flexDirection: 'column',
      //           //height: 900,
      //         }}
      //       >
      //         <ChatCard style={{ height: "100%" }}
      //           title="PIA Chat - Under Construction"


      //         />
      //       </Paper>
      //     </Card>
      //   </Grid>

      //   <Grid item xs={12} md={4} lg={6}>
      //     <Paper
      //       sx={{
      //         p: 2,
      //         display: 'flex',
      //         flexDirection: 'column',
      //         height: 300,
      //       }}
      //     >
      //       <PiaCard
      //         title="PIAs Requiring Updates"
      //         rows={data.expiringPias}
      //       />
      //     </Paper>
      //   </Grid>

      //   <Grid item xs={12} md={4} lg={6}>
      //     <Paper
      //       sx={{
      //         p: 2,
      //         display: 'flex',
      //         flexDirection: 'column',
      //         height: 300,
      //       }}
      //     >
      //       <ReportCard
      //         title="Reports"
      //         rows={data.reports}
      //       />
      //     </Paper>
      //   </Grid>

      // </Grid>

    );
  }
}
export default function Dashboard() {
  return <DashboardContent />;
}